import { Box, Heading, Link as ChakraLink } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

interface SessionProps {
  id: string;
  title: string;
  day: string;
  year: string;   // 追加
}

export default function Session({ id, title, year }: SessionProps) {
  return (
    <Box borderRadius="md" mb={4}>
      <Heading as="h3" size="md" mb={2}>
        <ChakraLink as={RouterLink} to={`/${year}/session/${id}`} color="blue.600">
          {title}
        </ChakraLink>
      </Heading>
    </Box>
  );
}